{% block swag_paypal_pos_wizard_finish %}
    <div class="swag-paypal-pos-wizard-finish">

        {% block swag_paypal_pos_wizard_finish_content %}
            <div class="swag-paypal-pos-wizard-finish__content">

                {% block swag_paypal_pos_wizard_finish_content_icon %}
                    <div class="swag-paypal-pos-wizard-finish__icon-wrapper">
                        <mt-icon class="swag-paypal-pos-wizard-finish__icon"
                                 name="regular-checkmark"
                                 size="80px"
                                 color="var(--color-icon-positive-default)" />
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_finish_content_header %}
                    <div class="swag-paypal-pos-wizard-finish__content-header">
                        {{ $t('swag-paypal-pos.wizard.finish.header') }}
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_finish_content_description %}
                    <div class="swag-paypal-pos-wizard-finish__content-description">
                        <p class="swag-paypal-pos-wizard-finish__first-paragraph">
                            {{ $t('swag-paypal-pos.wizard.finish.firstParagraph') }}
                        </p>

                        <p class="swag-paypal-pos-wizard-finish__second-paragraph">
                            {{ $t('swag-paypal-pos.wizard.finish.secondParagraph') }}
                        </p>
                    </div>
                {% endblock %}
            </div>
        {% endblock %}
    </div>
{% endblock %}
